import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
            keyword: "Keyword",
            location: "Location",
            radius: "Radius",
            locations: "Locations",
            search_locations: "Search Locations",
            any_job_type: "Any Job Type",
            travel_by: "Travel By",
            from: "From",
            within: "Within",
            walk: "Walk",
            bike: "Bike",
            car: "Car",
            public: "Public",
            by_driving: "by driving",
            by_walking: "by walking",
            by_bike: "by bike",
            by_public: "by public transport",
            mins: "Mins",
            mins_by: "Mins by",
            grid_view: "Grid View",
            map_view: "Map View",
            list_view: "List View",
            search: "Search",
            see_full_details: "See full details",
            show_filters: "Show filters",
            close_filters: "Close filters",
            show_results: "Show Results",
            showing: "Showing",
            of: "of",
            results: "results",
            for: "for",
            refine_results: "Refine Results",
            displaying: "Displaying",
            posted_by: "Posted by",
            yearly: "Yearly",
            daily: "Daily",
            hourly: "Hourly",
            currency_symbol: "£",
            load_more: "Load More",
            please_enter_a_location: "Please enter a location",
            commute_search: "Commute Search",
            salary_search: "Salary Search",
            something_went_wrong: "Something went wrong",
            try_again: "Try again",
            remote_working: "Remote Working",
            loading: "Loading",
            spelling: "Results for 'MISSPELLED_KEYWORD' could not be found. We think you meant 'CORRECT_KEYWORD'.",
            in: "in",
            miles: "Miles",
            error_title: "There are currently no positions available matching your search criteria.",
            error_body: "Please check your keyword and location preferences, consider increasing your search radius, or try removing filters to broaden your job search.",
            error_body2: "Alternatively, you can sign up to receive job alerts. If any suitable opportunities arise, you'll be the first to know.",
            error_logintext: "Sign up for job alerts.",
            today: "Today",
            yesterday: "Yesterday",
            few_days_ago: "A few days ago",
            number_of_minutes_by_commute_method_from_location_text: "(NUMBER_OF_MINUTES) min by (COMMUTE_METHOD) from (LOCATION_TEXT)",
            jan: "Jan",
            feb: "Feb",
            mar: "Mar",
            apr: "Apr",
            may: "May",
            jun: "Jun",
            jul: "Jul",
            aug: "Aug",
            sep: "Sep",
            oct: "Oct",
            nov: "Nov",
            dec: "Dec"
        }
      },
      ie: {
        translation: {
            keyword: "Keyword",
            location: "Location",
            radius: "Radius",
            locations: "Locations",
            search_locations: "Search Locations",
            any_job_type: "Any Job Type",
            travel_by: "Travel By",
            from: "From",
            within: "Within",
            walk: "Walk",
            bike: "Bike",
            car: "Car",
            public: "Public",
            by_driving: "by driving",
            by_walking: "by walking",
            by_bike: "by bike",
            by_public: "by public transport",
            mins: "Mins",
            mins_by: "Mins by",
            grid_view: "Grid View",
            map_view: "Map View",
            list_view: "List View",
            search: "Search",
            see_full_details: "See full details",
            show_filters: "Show filters",
            close_filters: "Close filters",
            show_results: "Show Results",
            showing: "Showing",
            of: "of",
            results: "results",
            for: "for",
            refine_results: "Refine Results",
            displaying: "Displaying",
            posted_by: "Posted by",
            yearly: "Yearly",
            daily: "Daily",
            hourly: "Hourly",
            currency_symbol: "€",
            load_more: "Load More",
            please_enter_a_location: "Please enter a location",
            commute_search: "Commute Search",
            salary_search: "Salary Search",
            something_went_wrong: "Something went wrong",
            try_again: "Try again",
            remote_working: "Remote Working",
            loading: "Loading",
            spelling: "Results for 'MISSPELLED_KEYWORD' could not be found. We think you meant 'CORRECT_KEYWORD'.",
            in: "in",
            miles: "Miles",
            error_title: "There are currently no positions available matching your search criteria.",
            error_body: "Please check your keyword and location preferences, consider increasing your search radius, or try removing filters to broaden your job search.",
            error_body2: "Alternatively, you can sign up to receive job alerts. If any suitable opportunities arise, you'll be the first to know.",
            error_logintext: "Sign up for job alerts.",
            today: "Today",
            yesterday: "Yesterday",
            few_days_ago: "A few days ago",
            number_of_minutes_by_commute_method_from_location_text: "(NUMBER_OF_MINUTES) min by (COMMUTE_METHOD) from (LOCATION_TEXT)",
            jan: "Jan",
            feb: "Feb",
            mar: "Mar",
            apr: "Apr",
            may: "May",
            jun: "Jun",
            jul: "Jul",
            aug: "Aug",
            sep: "Sep",
            oct: "Oct",
            nov: "Nov",
            dec: "Dec"
        }
      },
      us: {
        translation: {
            keyword: "Keyword",
            location: "Location",
            radius: "Radius",
            locations: "Locations",
            search_locations: "Search Locations",
            any_job_type: "Any Job Type",
            travel_by: "Travel By",
            from: "From",
            within: "Within",
            walk: "Walk",
            bike: "Bike",
            car: "Car",
            public: "Public",
            by_driving: "by driving",
            by_walking: "by walking",
            by_bike: "by bike",
            by_public: "by public transport",
            mins: "Mins",
            mins_by: "Mins by",
            grid_view: "Grid View",
            map_view: "Map View",
            list_view: "List View",
            search: "Search",
            see_full_details: "See full details",
            show_filters: "Show filters",
            close_filters: "Close filters",
            show_results: "Show Results",
            showing: "Showing",
            of: "of",
            results: "results",
            for: "for",
            refine_results: "Refine Results",
            displaying: "Displaying",
            posted_by: "Posted by",
            yearly: "Yearly",
            daily: "Daily",
            hourly: "Hourly",
            currency_symbol: "$",
            load_more: "Load More",
            please_enter_a_location: "Please enter a location",
            commute_search: "Commute Search",
            salary_search: "Salary Search",
            something_went_wrong: "Something went wrong",
            try_again: "Try again",
            remote_working: "Remote Working",
            loading: "Loading",
            spelling: "Results for 'MISSPELLED_KEYWORD' could not be found. We think you meant 'CORRECT_KEYWORD'.",
            in: "in",
            miles: "Miles",
            error_title: "There are currently no positions available matching your search criteria.",
            error_body: "Please check your keyword and location preferences, consider increasing your search radius, or try removing filters to broaden your job search.",
            error_body2: "Alternatively, you can sign up to receive job alerts. If any suitable opportunities arise, you'll be the first to know.",
            error_logintext: "Sign up for job alerts.",
            today: "Today",
            yesterday: "Yesterday",
            few_days_ago: "A few days ago",
            number_of_minutes_by_commute_method_from_location_text: "(NUMBER_OF_MINUTES) min by (COMMUTE_METHOD) from (LOCATION_TEXT)",
            jan: "Jan",
            feb: "Feb",
            mar: "Mar",
            apr: "Apr",
            may: "May",
            jun: "Jun",
            jul: "Jul",
            aug: "Aug",
            sep: "Sep",
            oct: "Oct",
            nov: "Nov",
            dec: "Dec"
        }
      },
      en_CH: {
        translation: {
            keyword: "Keyword",
            location: "Location",
            radius: "Radius",
            locations: "Locations",
            search_locations: "Search Locations",
            any_job_type: "Any Job Type",
            travel_by: "Travel By",
            from: "From",
            within: "Within",
            walk: "Walk",
            bike: "Bike",
            car: "Car",
            public: "Public",
            by_driving: "by driving",
            by_walking: "by walking",
            by_bike: "by bike",
            by_public: "by public transport",
            mins: "Mins",
            mins_by: "Mins by",
            grid_view: "Grid View",
            map_view: "Map View",
            list_view: "List View",
            search: "Search",
            see_full_details: "See full details",
            show_filters: "Show filters",
            close_filters: "Close filters",
            show_results: "Show Results",
            showing: "Showing",
            of: "of",
            results: "results",
            for: "for",
            refine_results: "Refine Results",
            displaying: "Displaying",
            posted_by: "Posted by",
            yearly: "Yearly",
            daily: "Daily",
            hourly: "Hourly",
            currency_symbol: "CHF",
            load_more: "Load More",
            please_enter_a_location: "Please enter a location",
            commute_search: "Commute Search",
            salary_search: "Salary Search",
            something_went_wrong: "Something went wrong",
            try_again: "Try again",
            remote_working: "Remote Working",
            loading: "Loading",
            spelling: "Results for 'MISSPELLED_KEYWORD' could not be found. We think you meant 'CORRECT_KEYWORD'.",
            in: "in",
            miles: "Miles",
            error_title: "There are currently no positions available matching your search criteria.",
            error_body: "Please check your keyword and location preferences, consider increasing your search radius, or try removing filters to broaden your job search.",
            error_body2: "Alternatively, you can sign up to receive job alerts. If any suitable opportunities arise, you'll be the first to know.",
            error_logintext: "Sign up for job alerts.",
            today: "Today",
            yesterday: "Yesterday",
            few_days_ago: "A few days ago",
            number_of_minutes_by_commute_method_from_location_text: "(NUMBER_OF_MINUTES) min by (COMMUTE_METHOD) from (LOCATION_TEXT)",
            jan: "Jan",
            feb: "Feb",
            mar: "Mar",
            apr: "Apr",
            may: "May",
            jun: "Jun",
            jul: "Jul",
            aug: "Aug",
            sep: "Sep",
            oct: "Oct",
            nov: "Nov",
            dec: "Dec"
        }
      },
      fr: {
        translation: {
            keyword: "Mot-clé",
            location: "Emplacement",
            radius: "Rayon",
            locations: "Emplacements",
            search_locations: "Rechercher des emplacements",
            any_job_type: "Tout type de travail",
            travel_by: "Voyager par",
            from: "De",
            within: "Dans",
            walk: "Marche",
            bike: "Vélo",
            car: "Voiture",
            public: "Public",
            by_driving: "en voiture",
            by_walking: " à pied",
            by_bike: "à vélo",
            by_public: "en transport en commun",
            mins: "Minutes",
            mins_by: "Minutes par",
            grid_view: "Vue Grille",
            map_view: "Vue Carte",
            list_view: "Vue Liste",
            search: "Recherche",
            see_full_details: "Voir tous les détails",
            show_filters: "Afficher les filtres",
            close_filters: "Fermer les filtres",
            show_results: "Afficher les résultats",
            showing: "Affichage",
            of: "de",
            results: "résultats",
            for: "pour",
            refine_results: "Affiner les résultats",
            displaying: "Affichage",
            posted_by: "Publié par",
            yearly: "Annuel",
            daily: "Quotidien",
            hourly: "Horaire",
            currency_symbol: "€",
            load_more: "Charger plus",
            please_enter_a_location: "Veuillez entrer un emplacement",
            commute_search: "Recherche de trajet",
            salary_search: "Recherche par salaire",
            something_went_wrong: "Quelque chose s'est mal passé",
            try_again: "Réessayer",
            remote_working: "Travail à distance",
            loading: "Chargement",
            spelling: "Aucun résultat trouvé pour 'MISSPELLED_KEYWORD'. Nous pensons que vous vouliez dire 'CORRECT_KEYWORD'.",
            in: "dans",
            miles: "Miles",
            error_title: "Il n'y a actuellement aucun poste disponible correspondant à vos critères de recherche.",
            error_body: "Veuillez vérifier vos mots-clés et vos préférences de localisation, envisagez d'augmenter votre rayon de recherche ou essayez de supprimer des filtres pour élargir votre recherche d'emploi.",
            error_body2: "Alternativement, vous pouvez vous inscrire pour recevoir des alertes emploi. Si des opportunités appropriées se présentent, vous serez le premier informé.",
            error_logintext: "Inscrivez-vous aux alertes emploi.",
            today: "Aujourd'hui",
            yesterday: "Hier",
            few_days_ago: "Il y a quelques jours",
            number_of_minutes_by_commute_method_from_location_text: "(NUMBER_OF_MINUTES) min by (COMMUTE_METHOD) from (LOCATION_TEXT)",
            jan: "Jan",
            feb: "Fév",
            mar: "Mars",
            apr: "Avr",
            may: "Mai",
            jun: "Juin",
            jul: "Juil",
            aug: "Août",
            sep: "Sept",
            oct: "Oct",
            nov: "Nov",
            dec: "Déc"
          }
      },
      fr_CH: {
        translation: {
            keyword: "Mot-clé",
            location: "Emplacement",
            radius: "Rayon",
            locations: "Emplacements",
            search_locations: "Rechercher des emplacements",
            any_job_type: "Tout type de travail",
            travel_by: "Voyager par",
            from: "De",
            within: "Dans",
            walk: "Marche",
            bike: "Vélo",
            car: "Voiture",
            public: "Public",
            by_driving: "en voiture",
            by_walking: " à pied",
            by_bike: "à vélo",
            by_public: "en transport en commun",
            mins: "Minutes",
            mins_by: "Minutes par",
            grid_view: "Vue Grille",
            map_view: "Vue Carte",
            list_view: "Vue Liste",
            search: "Recherche",
            see_full_details: "Voir tous les détails",
            show_filters: "Afficher les filtres",
            close_filters: "Fermer les filtres",
            show_results: "Afficher les résultats",
            showing: "Affichage",
            of: "de",
            results: "résultats",
            for: "pour",
            refine_results: "Affiner les résultats",
            displaying: "Affichage",
            posted_by: "Publié par",
            yearly: "Annuel",
            daily: "Quotidien",
            hourly: "Horaire",
            currency_symbol: "CHF",
            load_more: "Charger plus",
            please_enter_a_location: "Veuillez entrer un emplacement",
            commute_search: "Recherche de trajet",
            salary_search: "Recherche par salaire",
            something_went_wrong: "Quelque chose s'est mal passé",
            try_again: "Réessayer",
            remote_working: "Travail à distance",
            loading: "Chargement",
            spelling: "Aucun résultat trouvé pour 'MISSPELLED_KEYWORD'. Nous pensons que vous vouliez dire 'CORRECT_KEYWORD'.",
            in: "dans",
            miles: "Miles",
            error_title: "Il n'y a actuellement aucun poste disponible correspondant à vos critères de recherche.",
            error_body: "Veuillez vérifier vos mots-clés et vos préférences de localisation, envisagez d'augmenter votre rayon de recherche ou essayez de supprimer des filtres pour élargir votre recherche d'emploi.",
            error_body2: "Alternativement, vous pouvez vous inscrire pour recevoir des alertes emploi. Si des opportunités appropriées se présentent, vous serez le premier informé.",
            error_logintext: "Inscrivez-vous aux alertes emploi.",
            today: "Aujourd'hui",
            yesterday: "Hier",
            few_days_ago: "Il y a quelques jours",
            number_of_minutes_by_commute_method_from_location_text: "(NUMBER_OF_MINUTES) min by (COMMUTE_METHOD) from (LOCATION_TEXT)",
            jan: "Jan",
            feb: "Fév",
            mar: "Mars",
            apr: "Avr",
            may: "Mai",
            jun: "Juin",
            jul: "Juil",
            aug: "Août",
            sep: "Sept",
            oct: "Oct",
            nov: "Nov",
            dec: "Déc"
          }
      },
      es: {
        translation: {
            keyword: "Palabra clave",
            location: "Ubicación",
            radius: "Radio",
            locations: "Ubicaciones",
            search_locations: "Buscar ubicaciones",
            any_job_type: "Cualquier tipo de trabajo",
            travel_by: "Viajar por",
            from: "Desde",
            within: "Dentro de",
            walk: "Caminar",
            bike: "Bicicleta",
            car: "Coche",
            public: "Público",
            by_driving: "en coche",
            by_walking: "a pie",
            by_bike: "en bicicleta",
            by_public: "en transporte público",
            mins: "Minutos",
            mins_by: "Minutos en",
            grid_view: "Vista de cuadrícula",
            map_view: "Vista de mapa",
            list_view: "Vista de lista",
            search: "Buscar",
            see_full_details: "Ver detalles completos",
            show_filters: "Mostrar filtros",
            close_filters: "Cerrar filtros",
            show_results: "Mostrar resultados",
            showing: "Mostrando",
            of: "de",
            results: "resultados",
            for: "para",
            refine_results: "Refinar resultados",
            displaying: "Mostrando",
            posted_by: "Publicado por",
            yearly: "Anual",
            daily: "Diario",
            hourly: "Por hora",
            currency_symbol: "€",
            load_more: "Cargar más",
            please_enter_a_location: "Por favor, introduce una ubicación",
            commute_search: "Búsqueda de trayecto",
            salary_search: "Búsqueda por salario",
            something_went_wrong: "Algo salió mal",
            try_again: "Intentar de nuevo",
            remote_working: "Trabajo remoto",
            loading: "Cargando",
            spelling: "No se encontraron resultados para 'MISSPELLED_KEYWORD'. Creemos que quisiste decir 'CORRECT_KEYWORD'.",
            in: "en",
            miles: "Millas",
            error_title: "Actualmente no hay puestos disponibles que coincidan con tus criterios de búsqueda.",
            error_body: "Por favor, verifica tus palabras clave y preferencias de ubicación, considera aumentar el radio de búsqueda o intenta quitar filtros para ampliar tu búsqueda de empleo.",
            error_body2: "Alternativamente, puedes registrarte para recibir alertas de empleo. Si surgen oportunidades adecuadas, serás el primero en saberlo.",
            error_logintext: "Regístrate para alertas de trabajo.",
            today: "Hoy",
            yesterday: "Ayer",
            few_days_ago: "Hace unos días",
            number_of_minutes_by_commute_method_from_location_text: "(NUMBER_OF_MINUTES) min by (COMMUTE_METHOD) from (LOCATION_TEXT)",
            jan: "Ene",
            feb: "Feb",
            mar: "Mar",
            apr: "Abr",
            may: "May",
            jun: "Jun",
            jul: "Jul",
            aug: "Ago",
            sep: "Sep",
            oct: "Oct",
            nov: "Nov",
            dec: "Dic"
          }
      },
      de: {
        translation: {
            keyword: "Stichwort",
            location: "Standorte",
            radius: "Radius",
            locations: "Standorte",
            search_locations: "Standorte suchen",
            any_job_type: "Jeder Beschäftigungstyp",
            travel_by: "Reiseart",
            from: "Von",
            within: "Innerhalb",
            walk: "Zu Fuß",
            bike: "Fahrrad",
            car: "Auto",
            public: "Öffentliche Verkehrsmittel",
            by_driving: "mit dem Auto",
            by_walking: "zu Fuß",
            by_bike: "mit dem Fahrrad",
            by_public: "mit öffentlichen Verkehrsmitteln",
            mins: "Minuten",
            mins_by: "Minuten mit",
            grid_view: "Gitteransicht",
            map_view: "Kartenansicht",
            list_view: "Listenansicht",
            search: "Suchen",
            see_full_details: "Vollständige Details anzeigen",
            show_filters: "Filter anzeigen",
            close_filters: "Filter schließen",
            show_results: "Ergebnisse anzeigen",
            showing: "Anzeigen",
            of: "von",
            results: "Ergebnissen",
            refine_results: "Ergebnisse verfeinern",
            displaying: "Anzeige",
            posted_by: "Veröffentlicht von",
            yearly: "Jährlich",
            daily: "Täglich",
            hourly: "Stündlich",
            currency_symbol: "€",
            load_more: "Mehr laden",
            please_enter_a_location: "Bitte geben Sie einen Standort ein",
            commute_search: "Reisesuche",
            salary_search: "Gehaltssuche",
            something_went_wrong: "Es ist ein Fehler aufgetreten",
            try_again: "Versuchen Sie es erneut",
            remote_working: "Homeoffice",
            loading: "Wird geladen",
            spelling: "Ergebnisse für 'MISSPELLED_KEYWORD' konnten nicht gefunden werden. Wir glauben, Sie meinten 'CORRECT_KEYWORD'.",
            in: "in",
            miles: "Meilen",
            error_title: "Derzeit sind keine Stellen verfügbar, die Ihren Suchkriterien entsprechen.",
            error_body: "Bitte überprüfen Sie Ihre Stichwörter und Standortpräferenzen, erwägen Sie, Ihren Suchradius zu erhöhen, oder versuchen Sie, Filter zu entfernen, um Ihre Jobsuche zu erweitern.",
            error_body2: "Alternativ können Sie sich anmelden, um Stellenbenachrichtigungen zu erhalten. Wenn sich geeignete Möglichkeiten ergeben, werden Sie als Erster informiert.",
            error_logintext: "Melden Sie sich für Stellenbenachrichtigungen an.",
            today: "Heute",
            yesterday: "Gestern",
            few_days_ago: "Vor ein paar Tagen",
            number_of_minutes_by_commute_method_from_location_text: "(NUMBER_OF_MINUTES) min by (COMMUTE_METHOD) from (LOCATION_TEXT)",
            jan: "Jan",
            feb: "Feb",
            mar: "Mär",
            apr: "Apr",
            may: "Mai",
            jun: "Jun",
            jul: "Jul",
            aug: "Aug",
            sep: "Sep",
            oct: "Okt",
            nov: "Nov",
            dec: "Dez"
        }
      },
      de_CH: {
        translation: {
            keyword: "Stichwort",
            location: "Standorte",
            radius: "Radius",
            locations: "Standorte",
            search_locations: "Standorte suchen",
            any_job_type: "Jeder Beschäftigungstyp",
            travel_by: "Reiseart",
            from: "Von",
            within: "Innerhalb",
            walk: "Zu Fuß",
            bike: "Fahrrad",
            car: "Auto",
            public: "Öffentliche Verkehrsmittel",
            by_driving: "mit dem Auto",
            by_walking: "zu Fuß",
            by_bike: "mit dem Fahrrad",
            by_public: "mit öffentlichen Verkehrsmitteln",
            mins: "Minuten",
            mins_by: "Minuten mit",
            grid_view: "Gitteransicht",
            map_view: "Kartenansicht",
            list_view: "Listenansicht",
            search: "Suchen",
            see_full_details: "Vollständige Details anzeigen",
            show_filters: "Filter anzeigen",
            close_filters: "Filter schließen",
            show_results: "Ergebnisse anzeigen",
            showing: "Anzeigen",
            of: "von",
            results: "Ergebnissen",
            refine_results: "Ergebnisse verfeinern",
            displaying: "Anzeige",
            posted_by: "Veröffentlicht von",
            yearly: "Jährlich",
            daily: "Täglich",
            hourly: "Stündlich",
            currency_symbol: "CHF",
            load_more: "Mehr laden",
            please_enter_a_location: "Bitte geben Sie einen Standort ein",
            commute_search: "Reisesuche",
            salary_search: "Gehaltssuche",
            something_went_wrong: "Es ist ein Fehler aufgetreten",
            try_again: "Versuchen Sie es erneut",
            remote_working: "Homeoffice",
            loading: "Wird geladen",
            spelling: "Ergebnisse für 'MISSPELLED_KEYWORD' konnten nicht gefunden werden. Wir glauben, Sie meinten 'CORRECT_KEYWORD'.",
            in: "in",
            miles: "Meilen",
            error_title: "Derzeit sind keine Stellen verfügbar, die Ihren Suchkriterien entsprechen.",
            error_body: "Bitte überprüfen Sie Ihre Stichwörter und Standortpräferenzen, erwägen Sie, Ihren Suchradius zu erhöhen, oder versuchen Sie, Filter zu entfernen, um Ihre Jobsuche zu erweitern.",
            error_body2: "Alternativ können Sie sich anmelden, um Stellenbenachrichtigungen zu erhalten. Wenn sich geeignete Möglichkeiten ergeben, werden Sie als Erster informiert.",
            error_logintext: "Melden Sie sich für Stellenbenachrichtigungen an.",
            today: "Heute",
            yesterday: "Gestern",
            few_days_ago: "Vor ein paar Tagen",
            number_of_minutes_by_commute_method_from_location_text: "(NUMBER_OF_MINUTES) min by (COMMUTE_METHOD) from (LOCATION_TEXT)",
            jan: "Jan",
            feb: "Feb",
            mar: "Mär",
            apr: "Apr",
            may: "Mai",
            jun: "Jun",
            jul: "Jul",
            aug: "Aug",
            sep: "Sep",
            oct: "Okt",
            nov: "Nov",
            dec: "Dez"
        }
      },
        zh_CN: {
          translation: {
            keyword: "关键字",
            location: "位置",
            radius: "半径",
            locations: "地点",
            search_locations: "搜索地点",
            any_job_type: "任何工作类型",
            travel_by: "出行方式",
            from: "从",
            within: "在...之内",
            walk: "步行",
            bike: "自行车",
            car: "汽车",
            public: "公共交通",
            by_driving: " 驾车",
            by_walking: "步行",
            by_bike: " 骑自行车",
            by_public: "乘坐公共交通",
            mins: "分钟",
            mins_by: "分钟内",
            grid_view: "网格视图",
            map_view: "地图视图",
            list_view: "列表视图",
            search: "搜索",
            see_full_details: "查看全部细节",
            show_filters: "显示筛选器",
            close_filters: "关闭筛选器",
            show_results: "显示结果",
            showing: "正在显示",
            of: "的",
            results: "结果",
            for: "为了",
            refine_results: "细化结果",
            displaying: "展示中",
            posted_by: "发布者",
            yearly: "每年",
            daily: "每天",
            hourly: "每小时",
            currency_symbol: "¥",
            load_more: "加载更多",
            please_enter_a_location: "请输入一个位置",
            commute_search: "通勤搜索",
            salary_search: "薪资搜索",
            something_went_wrong: "出了些问题",
            try_again: "再试一次",
            remote_working: "远程工作",
            loading: "加载中",
            spelling: "'MISSPELLED_KEYWORD'的结果未找到。我们认为你的意思是'CORRECT_KEYWORD'。",
            in: "在",
            miles: "英里",
            error_title: "目前没有符合您搜索条件的职位空缺。",
            error_body: "请检查您的关键词和位置偏好，考虑增加搜索半径，或尝试移除过滤器以扩大您的工作搜索范围。",
            error_body2: "或者，您可以注册接收工作提醒。如果有合适的机会出现，您将第一个知道。",
            error_logintext: "注册工作提醒。",
            today: "今天",
            yesterday: "昨天",
            few_days_ago: "几天前",
            number_of_minutes_by_commute_method_from_location_text: "(NUMBER_OF_MINUTES) min by (COMMUTE_METHOD) from (LOCATION_TEXT)",
            jan: "1月",
            feb: "2月",
            mar: "3月",
            apr: "4月",
            may: "5月",
            jun: "6月",
            jul: "7月",
            aug: "8月",
            sep: "9月",
            oct: "10月",
            nov: "11月",
            dec: "12月"
          }
        },
        ca: {
          translation: {
            keyword: "Paraula clau",
            location: "Ubicació",
            radius: "Radi",
            locations: "Ubicacions",
            search_locations: "Cerca Ubicacions",
            any_job_type: "Qualsevol Tipus de Treball",
            travel_by: "Desplaçar-se amb",
            from: "Des de",
            within: "Dins de",
            walk: "Caminar",
            bike: "Bicicleta",
            car: "Cotxe",
            public: "Transport públic",
            by_driving: "en cotxe",
            by_walking: "a peu",
            by_bike: "en bicicleta",
            by_public: "en transport públic",
            mins: "Minuts",
            mins_by: "Minuts en",
            grid_view: "Vista de Quadrícula",
            map_view: "Vista de Mapa",
            list_view: "Vista de Llista",
            search: "Cerca",
            see_full_details: "Veure tots els detalls",
            show_filters: "Mostra filtres",
            close_filters: "Tanca filtres",
            show_results: "Mostra Resultats",
            showing: "Mostrant",
            of: "de",
            results: "resultats",
            for: "per",
            refine_results: "Refina Resultats",
            displaying: "Mostrant",
            posted_by: "Publicat per",
            yearly: "Anual",
            daily: "Diari",
            hourly: "Horari",
            currency_symbol: "€",
            load_more: "Carrega més",
            please_enter_a_location: "Si us plau, introdueix una ubicació",
            commute_search: "Cerca de commutació",
            salary_search: "Cerca per salari",
            something_went_wrong: "Alguna cosa ha anat malament",
            try_again: "Torna-ho a provar",
            remote_working: "Treball a distància",
            loading: "Carregant",
            spelling: "Els resultats per a 'MISSPELLED_KEYWORD' no s'han trobat. Creiem que volíeu dir 'CORRECT_KEYWORD'.",
            in: "a",
            miles: "Milles",
            error_title: "Actualment no hi ha cap posició disponible que coincideixi amb els vostres criteris de cerca.",
            error_body: "Si us plau, comproveu les vostres paraules clau i preferències de ubicació, considereu augmentar el radi de cerca o proveu de treure filtres per ampliar la vostra cerca de feina.",
            error_body2: "Alternativament, podeu registrar-vos per rebre alertes de feina. Si sorgeixen oportunitats adequades, seràs el primer a saber-ho.",
            error_logintext: "Inscriu-te per a alertes de treball.",
            today: "Avui",
            yesterday: "Ahir",
            few_days_ago: "Fa uns dies",
            number_of_minutes_by_commute_method_from_location_text: "(NUMBER_OF_MINUTES) min by (COMMUTE_METHOD) from (LOCATION_TEXT)",
            jan: "Gen",
            feb: "Feb",
            mar: "Març",
            apr: "Abr",
            may: "Maig",
            jun: "Juny",
            jul: "Juliol",
            aug: "Agost",
            sep: "Setembre",
            oct: "Octubre",
            nov: "Novembre",
            dec: "Desembre"
          }
        },
        nl: {
           translation: {
            keyword: "Trefwoord",
            location: "Locatie",
            radius: "Straal",
            locations: "Locaties",
            search_locations: "Zoek Locaties",
            any_job_type: "Elk Werktype",
            travel_by: "Reizen Met",
            from: "Vanaf",
            within: "Binnen",
            walk: "Lopen",
            bike: "Fiets",
            car: "Auto",
            public: "Openbaar Vervoer",
            by_driving: "met de auto",
            by_walking: "lopen",
            by_bike: "fietsen",
            by_public: "met het openbaar vervoer",
            mins: "Minuten",
            mins_by: "Minuten met",
            grid_view: "Rasterweergave",
            map_view: "Kaartweergave",
            list_view: "Lijstweergave",
            search: "Zoeken",
            see_full_details: "Bekijk volledige details",
            show_filters: "Toon filters",
            close_filters: "Sluit filters",
            show_results: "Toon Resultaten",
            showing: "Tonen",
            of: "van",
            results: "resultaten",
            for: "voor",
            refine_results: "Resultaten verfijnen",
            displaying: "Weergave",
            posted_by: "Geplaatst door",
            yearly: "Jaarlijks",
            daily: "Dagelijks",
            hourly: "Per uur",
            currency_symbol: "€",
            load_more: "Meer laden",
            please_enter_a_location: "Voer een locatie in",
            commute_search: "Reistijd Zoeken",
            salary_search: "Salaris Zoeken",
            something_went_wrong: "Er ging iets mis",
            try_again: "Probeer opnieuw",
            remote_working: "Op Afstand Werken",
            loading: "Laden",
            spelling: "'MISSPELLED_KEYWORD' kon niet worden gevonden. Bedoelde u 'CORRECT_KEYWORD'?",
            in: "in",
            miles: "Mijl",
            error_title: "Op dit moment zijn er geen posities beschikbaar die overeenkomen met uw zoekcriteria.",
            error_body: "Controleer alstublieft uw trefwoorden en locatievoorkeuren, overweeg uw zoekradius te vergroten, of probeer filters te verwijderen om uw banenzoekopdracht te verbreden.",
            error_body2: "Als alternatief kunt u zich aanmelden om vacaturemeldingen te ontvangen. Als er geschikte mogelijkheden ontstaan, bent u de eerste die het weet.",
            error_logintext: "Meld u aan voor vacature alerts.",
            today: "Vandaag",
            yesterday: "Gisteren",
            few_days_ago: "Een paar dagen geleden",
            number_of_minutes_by_commute_method_from_location_text: "(NUMBER_OF_MINUTES) min by (COMMUTE_METHOD) from (LOCATION_TEXT)",
            jan: "Jan",
            feb: "Feb",
            mar: "Mrt",
            apr: "Apr",
            may: "Mei",
            jun: "Jun",
            jul: "Jul",
            aug: "Aug",
            sep: "Sep",
            oct: "Okt",
            nov: "Nov",
            dec: "Dec"
          }
        },
        it: {
          translation: {
            keyword: "Parola chiave",
            location: "Posizione",
            radius: "Raggio",
            locations: "Posizioni",
            search_locations: "Cerca località",
            any_job_type: "Qualsiasi tipo di lavoro",
            travel_by: "Viaggiare con",
            from: "Da",
            within: "Entro",
            walk: "A piedi",
            bike: "Bici",
            car: "Auto",
            public: "Pubblico",
            by_driving: "in macchina",
            by_walking: "a piedi",
            by_bike: "in bicicletta",
            by_public: "in trasporto pubblico",
            mins: "Minuti",
            mins_by: "Minuti con",
            grid_view: "Vista griglia",
            map_view: "Vista mappa",
            list_view: "Vista elenco",
            search: "Cerca",
            see_full_details: "Vedi dettagli completi",
            show_filters: "Mostra filtri",
            close_filters: "Chiudi filtri",
            show_results: "Mostra risultati",
            showing: "Mostrando",
            of: "di",
            results: "risultati",
            for: "per",
            refine_results: "Affina risultati",
            displaying: "Visualizzando",
            posted_by: "Pubblicato da",
            yearly: "Annuale",
            daily: "Giornaliero",
            hourly: "Orario",
            currency_symbol: "€",
            load_more: "Carica altro",
            please_enter_a_location: "Inserisci una località",
            commute_search: " Ricerca tragitto",
            salary_search: "Ricerca stipendio",
            something_went_wrong: "Qualcosa è andato storto",
            try_again: "Riprova",
            remote_working: "Lavoro a distanza",
            loading: "Caricamento",
            spelling: "Risultati per 'MISSPELLED_KEYWORD' non trovati. Forse intendevi 'CORRECT_KEYWORD'.",
            in: "in",
            miles: "Miglia",
            error_title: "Attualmente non ci sono posizioni disponibili che corrispondono ai tuoi criteri di ricerca.",
            error_body: "Controlla le tue parole chiave e le preferenze di localizzazione, considera di aumentare il raggio di ricerca o prova a rimuovere i filtri per ampliare la tua ricerca di lavoro.",
            error_body2: "In alternativa, puoi registrarti per ricevere avvisi di lavoro. Se si presentano opportunità adatte, sarai il primo a saperlo.",
            error_logintext: "Iscriviti per ricevere avvisi di lavoro.",
            today: "Oggi",
            yesterday: "Ieri",
            few_days_ago: "Alcuni giorni fa",
            number_of_minutes_by_commute_method_from_location_text: "(NUMBER_OF_MINUTES) min by (COMMUTE_METHOD) from (LOCATION_TEXT)",
            jan: "Gen",
            feb: "Feb",
            mar: "Mar",
            apr: "Apr",
            may: "Mag",
            jun: "Giu",
            jul: "Lug",
            aug: "Ago",
            sep: "Set",
            oct: "Ott",
            nov: "Nov",
            dec: "Dic"
          }
        }
      }
  });

export default i18n;
